module.exports = __webpack_public_path__ + "img/suppen--dark.35e624d5.svg";